import enUS from "antd/locale/en_US";
import viVN from "antd/locale/vi_VN";
import type { Locale } from "antd/es/locale";

export const ANT_LOCALES: Record<string, Locale> = {
  en: enUS,
  vi: viVN,
};

const FALLBACK_LOCALE: Locale = enUS;

export { enUS, viVN, FALLBACK_LOCALE };

export function getAntLocale(lang: string): Locale {
  const normalized = lang.split("-")[0].toLowerCase();
  return ANT_LOCALES[normalized] ?? FALLBACK_LOCALE;
}
